export enum DemographicDistanceTab {
  DISTANCE = 'Distance',
  DRIVE_TIME = 'Drive Time',
}

export enum TransportationType {
  CYCLING = 'CYCLING',
  DRIVING = 'DRIVING',
  DRIVING_AND_TRAIN = 'DRIVING_AND_TRAIN',
  PUBLIC_TRANSPORT = 'PUBLIC_TRANSPORT',
  WALKING = 'WALKING',
  COACH = 'COACH',
  BUS = 'BUS',
  TRAIN = 'TRAIN',
  FERRY = 'FERRY',
  DRIVING_AND_FERRY = 'DRIVING_AND_FERRY',
  CYCLING_AND_FERRY = 'CYCLING_AND_FERRY',
}

export interface ITravelTime {
  departure_time: string;
  lat: number;
  lng: number;
  transportation: TransportationType;
  travel_time: number;
}

export interface ITravelTimeInput extends ITravelTime {
  geohierarchyLevels?: string[];
  singlePolygon?: boolean;
}

export interface IDistance {
  distance: {
    selected: number[];
    all: number[];
  };
  drivingTime: {
    selected: number[];
    all: number[];
  };
  currentTab: DemographicDistanceTab;
}
